import dayjs from 'dayjs';

export default function timeFormat(time, format = 'YYYY-MM-DD HH:mm') {
  return dayjs(time).format(format);
}
